import React from 'react'

const CurrencyPage=()=> {
  return (
    <div>CurrencyPage</div>
  )
}

export default CurrencyPage